import { useTranslation } from 'react-i18next'

import { Alert, AlertDescription, AlertTitle, PageHeader } from '@/shared/ui'

import { ChangePasswordCard } from '../components/change-password-card'
import { SessionsCard } from '../components/sessions-card'

import '../i18n'

/**
 * `isPasswordChangeRequired` arrives as a prop rather than being read from the
 * session query: features do not import from `src/app`, so the route owns that
 * lookup and hands the answer down.
 */
export function AccountPage({ isPasswordChangeRequired }: { isPasswordChangeRequired: boolean }) {
  const { t } = useTranslation(['auth', 'common'])

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title={isPasswordChangeRequired ? t('account.forcedTitle') : t('account.title')}
        description={isPasswordChangeRequired ? undefined : t('account.description')}
      />

      {isPasswordChangeRequired && (
        <Alert>
          <AlertTitle>{t('account.forcedTitle')}</AlertTitle>
          <AlertDescription>{t('account.forcedDescription')}</AlertDescription>
        </Alert>
      )}

      {/* Full width, stacked: a form and a list have nothing like the same
          mass, and a grid would leave a hole under the shorter one. */}
      <ChangePasswordCard />

      {/* Sessions are noise while the password is the only thing that matters. */}
      {!isPasswordChangeRequired && <SessionsCard />}
    </div>
  )
}
